import React, { Component } from 'react';
import "./index.less";
import { getPlatformName, requests, messageShow, getLoginShopInfo, matchSupplierProduct, systemConfig } from '../../utils/http.js';
import PlatformName from '../platformName/index.jsx';
import ShowModal from '../showModal/index.jsx';
import MyLoading from '../showLoading/showLoading.jsx';
import { LoadProductSkuMappingV2Request, RelateProductV2Request } from '../../utils/api.js';
import { withRouter } from 'react-router-dom';
import { huoyuanLink } from '../../utils/index.js';

class skuMappingsModule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            loadingTitle: '',
            productId: props.productId,
            shopId: props.shopId,
            platformType: props.platformType,
            isShowDailog: props.showModal,
            selectProductSkuId: props.selectProductSkuId,
            selectOrderCode: props.selectOrderCode,
            orderItemCode: props.orderItemCode,
            relationSupplierProducts: [
                { PicURI: 'https://img.alicdn.com/imgextra/i4/2215261123823/O1CN01aWQjep1e6yxxBjAis_!!2215261123823-0-tblite.jpg', Subject: '【买一送一】凡士林+维生素e乳滋润补水保湿霜绵羊油面霜润肤膏', ProductId: '670602614158', SourcePlatform: 'TaoteZhuKe' },
                { PicURI: 'https://img.alicdn.com/imgextra/i4/2215261123823/O1CN01aWQjep1e6yxxBjAis_!!2215261123823-0-tblite.jpg', Subject: '【买一送一】凡士林+维生素e乳滋润补水保湿霜绵羊油面霜润肤膏', ProductId: '665064741732', SourcePlatform: '' },
                { PicURI: 'https://img.alicdn.com/imgextra/i4/2215261123823/O1CN01aWQjep1e6yxxBjAis_!!2215261123823-0-tblite.jpg', Subject: '【买一送一】凡士林+维生素e乳滋润补水保湿霜绵羊油面霜润肤膏', ProductId: '665064741732', SourcePlatform: '' },
                { PicURI: 'https://img.alicdn.com/imgextra/i4/2215261123823/O1CN01aWQjep1e6yxxBjAis_!!2215261123823-0-tblite.jpg', Subject: '【买一送一】凡士林+维生素e乳滋润补水保湿霜绵羊油面霜润肤膏', ProductId: '665064741732', SourcePlatform: '' },
            ],//代销货源信息
            selectProduct: null,//店铺商品信息
            relations: [],
            isShowAddSupplierProduct: false,//是否展示添加货源
            isShowDelSupplierProduct: false,//是否展示删除货源
            delSupplierProduct: null,
            skuMappingsTitle: props.skuMappingsTitle ? props.skuMappingsTitle : '确定',
            isOrderListOpen: props.isOrderListOpen,
            isChecked: false,
            noRelationSupplierProducts: [],
            isTwoOpen: props.isTwoOpen
        };
    }
    componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。

    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        const productId = props.productId
        const shopId = props.shopId
        const platformType = props.platformType
        const relationData = props.relationData
        const selectProductSkuId = props.selectProductSkuId
        const selectOrderCode = props.selectOrderCode
        const isShowAddSupplierProduct = props.isShowAddSupplierProduct
        const isShowDelSupplierProduct = props.isShowDelSupplierProduct
        const orderItemCode = props.orderItemCode
        const isTwoOpen = props.isTwoOpen
        if (props.showModal != this.state.isShowDailog && props.showModal == true) {
            if (productId) {
                this.loadProductSkuMappingV2(shopId, productId, selectOrderCode, orderItemCode)
            }
        }

        if (relationData) {
            this.initData(relationData.Relation, relationData.SupplierProducts, relationData.ProductFx, selectProductSkuId)
            this.state.selectProduct = relationData.ProductFx
            this.state.relationSupplierProducts = relationData.SupplierProducts
            this.state.relations = relationData.Relation
            this.state.noRelationSupplierProducts = relationData.SupplierProducts.filter(function (item) {
                return item.SupportEncryptOrder === false
            })
        }
        this.setState({
            isShowDailog: props.showModal,
            productId: productId,
            shopId: shopId,
            platformType: platformType,
            selectProductSkuId: selectProductSkuId,
            isShowAddSupplierProduct: isShowAddSupplierProduct,
            isShowDelSupplierProduct: isShowDelSupplierProduct,
            skuMappingsTitle: props.skuMappingsTitle,
            selectOrderCode: selectOrderCode,
            orderItemCode: orderItemCode,
            isTwoOpen: isTwoOpen
        })
    }
    async loadProductSkuMappingV2(shopId, productId, selectOrderCode, orderItemCode) {
        const data = {
            ShopId: shopId,
            ProductId: productId,
            OrderCode: selectOrderCode
        }
        if (orderItemCode) {
            data.OrderItemCode = orderItemCode;
        }
        this.setState({ isLoading: true })
        const res = await LoadProductSkuMappingV2Request(data);
        this.setState({ isLoading: false })
        if (!res.Success) {
            messageShow('加载规格数据失败：' + res.Message, 'error')
            return
        }

        let selectProductData = [];
        selectProductData = res.Data && res.Data.ProductFx;

        let selectProductSkuId = this.state.selectProductSkuId;

        if (selectProductSkuId) {
            let itemToMove = selectProductData.Skus.find(item => item.SkuId == selectProductSkuId);
            let fIndex = selectProductData.Skus.findIndex(item => item.SkuId == selectProductSkuId);
            if (fIndex !== -1) {
                selectProductData.Skus.splice(fIndex, 1); // 移除找到的项
                selectProductData.Skus.unshift(itemToMove); // 将项置顶
            }
        }

        this.state.selectProduct = selectProductData;
        this.state.relationSupplierProducts = (res.Data && res.Data.SupplierProducts) || [];
        let relations = (res.Data && res.Data.Relation) || [];
        this.state.relations = relations;
        let selectProduct = this.state.selectProduct;

        const supplierProducts = this.state.relationSupplierProducts;
        this.state.noRelationSupplierProducts = supplierProducts.filter(function (item) {
            return item.SupportEncryptOrder === false
        })
        this.initData(relations, supplierProducts, selectProduct, selectProductSkuId);
        this.state.relations = relations;
        console.log('selectProduct =>', selectProduct);
        this.setState({})
    }

    initData(relations, supplierProducts, selectProduct, selectProductSkuId) {
        relations.forEach(x => {
            x.SkuMappings = x.SkuMappings || []
            x.SkuMappings.forEach(mapping => {
                mapping.SourcePlatform = !mapping.SourcePlatform ? 'AlibabaZhuKe' : mapping.SourcePlatform
                mapping.MappingCount = mapping.MappingCount == 0 ? 1 : mapping.MappingCount//如果发现后台返回值的mappingcount为0，改为1
            })
        })

        supplierProducts.forEach(supplierProduct => {
            supplierProduct.SourcePlatform = !supplierProduct.SourcePlatform ? 'AlibabaZhuKe' : supplierProduct.SourcePlatform
        })
        for (let supplierProduct of supplierProducts) {
            supplierProduct.Skus = supplierProduct.Skus || [];
            for (let sku of supplierProduct.Skus) {
                sku.lable = sku.Color + sku.Size
                sku.SourcePlatform = supplierProduct.SourcePlatform
            }
        }

        console.log("selectProduct", selectProduct)

        if (selectProduct) {
            selectProduct.Skus = selectProduct.Skus || [];

            if (selectProductSkuId) {
                let itemToMove = selectProduct.Skus.find(item => item.SkuId == selectProductSkuId);
                let fIndex = selectProduct.Skus.findIndex(item => item.SkuId == selectProductSkuId);
                if (fIndex !== -1) {
                    selectProduct.Skus.splice(fIndex, 1); // 移除找到的项
                    selectProduct.Skus.unshift(itemToMove); // 将项置顶
                }
            }

            const skuMappings = relations.flatMap(x => x.SkuMappings);
            for (let sku of selectProduct.Skus) {
                const mappings = skuMappings.filter(x => x.SkuId == sku.SkuId);

                sku.mappings = mappings.map(x => {
                    let SelectSkuTitle = '';
                    let SelectSupplierProductName = '';
                    for (let i = 0; i < supplierProducts.length; i++) {
                        supplierProducts[i].Skus = supplierProducts[i].Skus || [];
                        for (let supplierSku of supplierProducts[i].Skus) {
                            if (supplierSku.SkuId == x.SupplierSkuId) {
                                SelectSkuTitle = supplierSku.lable;
                                SelectSupplierProductName = '货源' + (i + 1);
                            }
                        }
                    }

                    return {
                        SupplierProductId: x.SupplierProductId,
                        SourcePlatform: x.SourcePlatform,
                        SkuId: x.SkuId,
                        SupplierSkuId: x.SupplierSkuId,
                        SupplierSpecId: x.SupplierSpecId,
                        MappingCount: x.MappingCount,
                        RelationCode: x.RelationCode,
                        showSupplierProduct: x.SupplierProductId,//页面展示切换货源使用
                        SelectSupplierProductName: SelectSupplierProductName,
                        SelectSkuTitle: SelectSkuTitle,
                        isShowMoreSku: false
                    }
                })
                if (sku.mappings.length == 0) {
                    sku.mappings.push({
                        ProductId: selectProduct.PlatformId,
                        SkuId: sku.SkuId,
                        MappingCount: 1,
                        SelectSupplierProductName: '',
                        SelectSkuTitle: '',
                        isShowMoreSku: false
                    })
                }
            }
        }
    }

    changeForm(name, value) {
        this.state[name] = value
        this.setState({})
    }
    showSupplierProduct(mapping, supplierProduct, index02, isTrue) {
        mapping.showSupplierProduct = supplierProduct.ProductId;
        this.setState({})
    }
    setMapping(mapping, supplierProductSku, mappings, Id, indxe) {
        const hasExists = mappings.filter(x => x.SupplierProductId == supplierProductSku.ProductId && x.SupplierSkuId == supplierProductSku.SkuId && x != mapping)
        if (hasExists.length > 0) {
            messageShow('该供应商规格在组合中已存在！', 'warning')
            return
        }
        if (mapping.mappingCount) {
            if (!(/(^[1-9]\d*$)/.test(mapping.mappingCount))) {
                messageShow("数量必须填正整数的", "warning");
                return;
            }
        }

        const sourceIndex = this.state.relationSupplierProducts.findIndex(x => supplierProductSku.SourcePlatform == x.SourcePlatform && supplierProductSku.ProductId == x.ProductId)
        mapping.SupplierSkuId = supplierProductSku.SkuId;
        mapping.SupplierProductId = supplierProductSku.ProductId;
        mapping.SourcePlatform = supplierProductSku.SourcePlatform;
        mapping.SelectSkuTitle = supplierProductSku.lable;
        mapping.SelectSupplierProductName = "货源" + (sourceIndex + 1);
        this.setState({});
        this.showSelectMappings(Id, indxe, mapping);

    }
    delMapping(mappings, mapping) {
        const index = mappings.findIndex(x => x == mapping)
        if (index > -1) {
            mappings.splice(index, 1)
        }
        this.setState({})
    }
    addMapping(mappings, productSku) {
        mappings.push({
            ProductId: productSku.PlatformId,
            SkuId: productSku.SkuId,
            MappingCount: 1,
        })

        this.setState({})
    }
    setMappingCount(mappingCnt, mapping) {
        mapping.MappingCount = mappingCnt;
        this.setState({})
    }
    closeSkuMappingsModule() {
        this.state.isShowDailog = false;
        this.state.relationSupplierProducts = []
        this.state.noRelationSupplierProducts = []
        this.state.selectProduct = null
        this.state.selectOrderCode = null;
        this.setState({})
        this.props.closeSkuMappingsModule();
    }
    saveSure = async () => {
        const data = this.initPostData();
        const mappings = data.Relations.flatMap(x => x.SkuMappings);
        console.log('data =>', data);
        if (data.Relations.length == 0) {
            messageShow('供应商规格不能全部为空', 'warning')
            return
        }
        if (mappings.length == 0) {
            messageShow('供应商规格不能全部为空', 'warning')
            return
        }
        if (typeof this.props.saveSure == 'function') {
            this.props.saveSure(data);
        }
        else {
            this.setState({ isLoading: true })
            const res = await RelateProductV2Request(data);
            this.setState({ isLoading: false })
            if (!res.Success) {
                messageShow(res.Message, 'error')
                return;
            }
            messageShow("关联成功，可到代销商品中查看。", 'success');
            this.closeSkuMappingsModule();
        }
    }

    initPostData = () => {
        const data = {}
        data.TargetShopId = this.state.shopId
        data.TargetShopPt = this.state.platformType
        data.Relations = []
        const product = this.state.selectProduct
        const mappings = product.Skus.filter(x => x.mappings && x.mappings.length > 0)
            .flatMap(x => x.mappings)
            .filter(x => x.SupplierSkuId && x.MappingCount > 0);

        for (const suppliProduct of this.state.relationSupplierProducts) {
            const tempMappinags = mappings.filter(x => x.SupplierProductId == suppliProduct.ProductId && x.SourcePlatform == suppliProduct.SourcePlatform);
            data.Relations.push({
                SupplierProductId: suppliProduct.ProductId,
                SourcePlatform: suppliProduct.SourcePlatform,
                ProductId: this.state.selectProduct.PlatformId,
                SkuMappings: tempMappinags.map(mapping => {
                    return {
                        SkuId: mapping.SkuId,
                        SupplierSkuId: mapping.SupplierSkuId,
                        MappingCount: mapping.MappingCount,
                    }
                }),
            })
        }
        return data;
    }

    showSelectMappings = (skuId, index, mapping) => {
        let selectProduct = this.state.selectProduct;
        const show = !mapping.isShowMoreSku;
        selectProduct.Skus.forEach((item, cIndex) => {
            item.mappings.forEach((cItem, i) => {
                cItem.isShowMoreSku = false;
            })
        })
        mapping.isShowMoreSku = show;
        this.setState({ selectProduct });
    }

    hideAllSelectMappings = () => {
        let selectProduct = this.state.selectProduct;
        selectProduct.Skus.forEach((item, cIndex) => {
            item.mappings.forEach((cItem, i) => {
                cItem.isShowMoreSku = false;
            })
        })
        this.setState({ selectProduct });
    }

    stopM = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }

    addSupplierProduct = () => {

        const hasTaoteRelation = this.state.relations.find(x => x.SourcePlatform == 'TaoteZhuKe');
        if (hasTaoteRelation) {
            messageShow('已关联淘特货源商品，不允许添加多货源', 'error')
            return;
        }
        const data = {};
        data.ProductFx = this.state.selectProduct;
        data.Relation = this.state.relations;
        data.SupplierProducts = this.state.relationSupplierProducts;
        this.props.showAddSupplierProduct(data);
    }

    changeSupplierProduct = (item) => {
        const data = {
            changeSupplierProduct: item,
            selectProductId: this.state.selectProduct.PlatformId
        }

        this.props.onChangeSupplierProduct(data);
    }

    handleChange(val) {
        this.setState({
            isChecked: val
        })
    }

    delSupplierProductDialog = (item, index) => {
        const mappings = []
        for (const sku of this.state.selectProduct.Skus) {
            mappings.push(...sku.mappings.filter(x => x.SourcePlatform == item.SourcePlatform && x.SupplierProductId == item.ProductId))
        }
        console.log('mappings =>', item)
        this.setState({
            delSupplierProductDialog: true,
            delSupplierProduct: item,
            delSupplierProductHasMapping: mappings.length > 0,
        })
    }
    delSupplierProduct = () => {
        const item = this.state.delSupplierProduct;
        const supplierProductIndex = this.state.relationSupplierProducts.findIndex(x => x.SourcePlatform == item.SourcePlatform && x.ProductId == item.ProductId);

        if (supplierProductIndex != -1) {
            this.state.relationSupplierProducts.splice(supplierProductIndex, 1);
        }
        for (const sku of this.state.selectProduct.Skus) {
            sku.mappings = sku.mappings.filter(x => x.SourcePlatform != item.SourcePlatform || x.SupplierProductId != item.ProductId)
        }
        const relationIndex = this.state.relations.findIndex(x => x.SupplierProductId == item.ProductId && x.SourcePlatform == item.SourcePlatform)
        if (relationIndex != -1) {
            this.state.relations.splice(relationIndex, 1);
        }
        this.initData(this.state.relations, this.state.relationSupplierProducts, this.state.selectProduct, this.state.selectProductSkuId)

        this.setState({
            delSupplierProductDialog: false,
            delSupplierProduct: null,
        })
    }

    tableRender() {
        var ele =
            <div className="dailogSkuMapWrap-down" onClick={() => this.hideAllSelectMappings()}>
                <table className="table-style01">
                    <thead>
                        <tr>
                            <th style={{ width: "350px" }}>
                                <span>{getPlatformName(this.state.selectPlatformTypeRelevance)}店铺商品规格</span>
                                <span></span>
                            </th>
                            <th style={{ width: "410px", padding: '8px 0' }}>
                                <div className='leftRightOperate'>
                                    <span>待采购的货源规格</span>
                                    <span>采购数量</span>
                                </div>
                            </th>
                            <th style={{ width: "130px", textAlign: 'right' }}>操作</th>
                        </tr>
                    </thead>
                    <tbody className='scroll-x' style={{ maxHeight: '220px', overflowY: 'auto' }}>
                        {
                            this.state.selectProduct == null || this.state.selectProduct.Skus.length == 0 ?
                                <tr>
                                    <td className="noneData" colSpan="4">
                                        <div className="noneData-wrap">
                                            <i className="iconfont icon-wushuju"></i>
                                            <span className="noneData-title">暂无数据！</span>
                                        </div>
                                    </td>
                                </tr> :
                                this.state.selectProduct.Skus
                                    .filter(x =>
                                        this.state.selectProductSkuId ? x.SkuId == this.state.selectProductSkuId || this.state.isTwoOpen : (this.state.isShowDeletedSku || x.SystemStatus != -1))
                                    .map((item, index) =>
                                        <tr>
                                            <td className='selectProductSkuWrap'>
                                                <div className='selectProductSkuWrap-title'>
                                                    {this.state.selectProductSkuId && item.SkuId == this.state.selectProductSkuId ? <span style={{ width: '32px', color: '#bbb' }}>订单规格</span> : null}
                                                    {item.AttributeValue1}{item.AttributeValue2}
                                                </div>
                                            </td>
                                            {
                                                item.mappings != null && item.mappings.length > 0 ?
                                                    <td>
                                                        {
                                                            item.mappings.map((supItem, index) =>
                                                                <div className='leftRightOperateWrap'>

                                                                    <div className='leftRightOperate-left '>
                                                                        <div className='mySelectWrap' onClick={(e) => this.stopM(e)}>
                                                                            <div className="mySelectWrap-titleWrap" onClick={() => this.showSelectMappings(item.Id, index, supItem)}>
                                                                                {
                                                                                    supItem.SelectSupplierProductName && supItem.SelectSkuTitle ?
                                                                                        <span className='mySelectWrap-titleWrap-showTitle'>
                                                                                            {supItem.SelectSupplierProductName}：
                                                                                            {supItem.SelectSkuTitle}
                                                                                        </span> :
                                                                                        <span className='mySelectWrap-titleWrap-title'>请选择</span>

                                                                                }
                                                                                <i className={supItem.isShowMoreSku ? 'mySelectWrap-titleWrap-icon active' : 'mySelectWrap-titleWrap-icon'}></i>
                                                                            </div>

                                                                            <div className={supItem.isShowMoreSku ? "mySelectWrap-content active" : "mySelectWrap-content"}>
                                                                                <ul className='mySelectWrap-content-left scroll-x'>
                                                                                    {
                                                                                        this.state.relationSupplierProducts.map((supplierProduct, index02) =>
                                                                                            supItem.showSupplierProduct == supplierProduct.ProductId ?
                                                                                                <li checked className='content-left-item hover defColor' onClick={() => { this.showSupplierProduct(supItem, supplierProduct, (index02 + 1), false) }}>
                                                                                                    <span className='content-left-item-title'>货源{index02 + 1}</span>
                                                                                                    <span className='iconfont icon-xiangxia'></span>
                                                                                                </li>
                                                                                                : <li className='content-left-item hover' onClick={() => { this.showSupplierProduct(supItem, supplierProduct, (index02 + 1), true) }}>
                                                                                                    <span className='content-left-item-title'>货源{index02 + 1}</span>
                                                                                                    <span className='iconfont icon-xiangxia'></span>
                                                                                                </li>
                                                                                        )
                                                                                    }
                                                                                </ul>
                                                                                <ul className='mySelectWrap-content-right scroll-x'>
                                                                                    {
                                                                                        this.state.relationSupplierProducts
                                                                                            .filter(x => x.ProductId == supItem.showSupplierProduct).flatMap(x => x.Skus)
                                                                                            .map((sku, index02) =>
                                                                                                sku.ProductId == supItem.SupplierProductId && sku.SkuId == supItem.SupplierSkuId ?
                                                                                                    <li checked className='content-right-item over defColor' onClick={(() => { this.setMapping(supItem, sku, item.mappings, item.Id, index02) })}>
                                                                                                        <span className='content-right-item-title'>{sku.lable}</span>
                                                                                                    </li>
                                                                                                    : <li className='content-right-item hover' onClick={(() => { this.setMapping(supItem, sku, item.mappings, item.Id, index02) })}>
                                                                                                        <span className='content-right-item-title'>{sku.lable}</span>
                                                                                                    </li>
                                                                                            )
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                        </div>


                                                                    </div>

                                                                    <input className='leftRightOperate-right' type='number' value={supItem.MappingCount} onChange={(e) => this.setMappingCount(e.target.value, supItem)}></input>
                                                                    {
                                                                        item.mappings.length > 1 ?
                                                                            <span className='dangerColor hover' onClick={(e) => this.delMapping(item.mappings, supItem)}>删除</span> :
                                                                            null
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                    </td> : null
                                            }
                                            <td style={{ textAlign: 'right', paddingRight: '5px' }}><span className='defColor hover' onClick={(e) => this.addMapping(item.mappings, item)}>添加规格</span></td>
                                        </tr>
                                    )
                        }
                    </tbody>
                </table>
            </div>

        return ele;
    }
    render() {
        return (
            <ShowModal
                showLeftTopBtn={true}
                width={900}
                showModal={this.state.isShowDailog}
                titleName={this.state.skuMappingsTitle || '匹配规格'}
                skin={"skuMappingsModule"}
                hideBtn={true}
                cancelDailog={() => { this.closeSkuMappingsModule() }} //取消按钮回调函数
            >

                <div className="showModalWrap-box-commonContent changeProductsWrap-commonContent scroll-x skuMappingsWrap-commonContent newSkuMappingsWrap">

                    <div className="showModalWrap-commonContent-item">
                        <div className='tagStatus tagWarn tagStatusWrap'>
                            <span style={{ color: '#666' }}>关联货源 <i className='iconfont icon-xiangxia'></i> 规格匹配 <i className='iconfont icon-xiangxia' style={{ fontSize: '15px' }}></i> 订单自动回流采购</span>
                            <div className='iconfont icon-tips'>
                                <div className='icon-tips-content' style={{ marginTop: '-150px' }}>
                                    <span>1、关联或更换货源时，注意货源的起批量，避免因起批量不足导致不能正常采购。</span>
                                    <span>2、关联或更换货源后，请进行规格匹配，匹配后店铺商品被买家下单时，将会按您匹配的货源规格进行采购，并同步发货和物流信息;</span>
                                    <span>3、您和供应商任意一方修改规格名/删除规格，都会导致匹配关系失效，需要重新进行匹配规格。</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        {
                            this.state.platformType == "Taobao" && this.state.isOrderListOpen ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', marginBottom: '6px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <input style={{ cursor: 'pointer', marginTop: '2px' }} type="checkbox" checked={this.state.isChecked} onChange={(e) => this.handleChange(e.target.checked)} />
                                    不支持密文货源
                                </label>
                            </div> : null
                        }
                        <div className='second-SkuMapWrap-top'>
                            <div className="dailogSkuMapWrap-up">
                                <div style={{ width: '100%' }}>
                                    <div className="dailogSkuMapWrap-up-title">
                                        <span>店铺商品</span>
                                    </div>
                                    <div className="dailogSkuMapWrap-up-main">
                                        <div className="productShow table-product">
                                            <div className="productShow-imgWrap">
                                                <img src={this.state.selectProduct && this.state.selectProduct.ImageUrl} alt="" />
                                            </div>
                                            <ul>
                                                <li title="商品标题">{this.state.selectProduct && this.state.selectProduct.Subject}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='dailogSkuMapWrap-mid'>
                                <span>对应货源</span>
                                <i className='iconfont icon-fanhuidingbu'></i>
                            </div>
                            <div className="dailogSkuMapWrap-up">
                                <div className="dailogSkuMapWrap-up-title">
                                    <div className='dailogSkuMapWrap-up-titleWrap'>
                                        {
                                            this.state.isChecked ? <span>不支持密文货源（{this.state.noRelationSupplierProducts.length}个商品）</span> :
                                                <span>已关联货源商品（{this.state.relationSupplierProducts.length}个商品）</span>
                                        }
                                        {
                                            this.state.isShowAddSupplierProduct ?
                                                <div className='hover addSupplierProductTitle' onClick={() => { this.addSupplierProduct() }}>
                                                    <span>+</span>
                                                    <span className='addSupplierProductTitle-text'>新增货源</span>
                                                </div> : null
                                        }
                                    </div>
                                </div>
                                <div className="dailogSkuMapWrap-up-main scroll-x">

                                    {

                                        this.state.isChecked && this.state.noRelationSupplierProducts.length > 0 ? this.state.noRelationSupplierProducts.map((supplierProduct, index) =>
                                            <div className="productShow table-product">
                                                <div className="productShow-imgWrap">
                                                    <img src={supplierProduct.PicURI} alt="" />
                                                    <span className='productShow-imgWrap-status'>货源{index + 1}</span>
                                                </div>
                                                <ul>
                                                    <li title="商品标题">
                                                        <span className='hover defColor' onClick={() => { huoyuanLink(supplierProduct) }}>{supplierProduct.Subject}</span>
                                                        {supplierProduct.PickupAssr ? <span className='productShow-content-sku-tag' style={{ alignItems: 'center' }}>{supplierProduct.PickupAssr}h晚揽必赔</span> : null}
                                                    </li>
                                                    <li className='supplierProduct-danger' style={{ display: 'flex' }}>
                                                        <span>供应商旺旺：{supplierProduct.SupplierLoginId}</span>
                                                        {
                                                            this.state.isShowDelSupplierProduct ?
                                                                <div>
                                                                    <span className='hover iconfont icon-laji' onClick={() => { this.delSupplierProductDialog(supplierProduct, index) }}></span>
                                                                </div> : null
                                                        }
                                                    </li>
                                                    <li>{
                                                        !supplierProduct.SupportEncryptOrder && this.state.platformType == "Taobao" ?
                                                            <span className='dangerColor'>货源不支持密文下单
                                                                {
                                                                    this.state.isOrderListOpen ?
                                                                        <span style={{ marginLeft: '6px' }} className='hover defColor' onClick={() => { this.changeSupplierProduct(supplierProduct) }}>替换货源</span> : null
                                                                }
                                                            </span>
                                                            : null
                                                    }</li>
                                                    <li>{
                                                        supplierProduct.SourcePlatform == 'TaoteZhuKe' ?
                                                            <span className='dangerColor'>! 已不支持淘特货源分销，请更换1688货源</span> : null
                                                    }</li>
                                                </ul>
                                            </div>
                                        ) : this.state.isChecked && this.state.noRelationSupplierProducts.length === 0 ? <div style={{ height: '50px', lineHeight: '50px', color: '#bbb' }}>暂无不支持密文货源</div> :
                                            this.state.relationSupplierProducts.map((supplierProduct, index) =>
                                                <div className="productShow table-product">
                                                    <div className="productShow-imgWrap">
                                                        <img src={supplierProduct.PicURI} alt="" />
                                                        <span className='productShow-imgWrap-status'>货源{index + 1}</span>
                                                    </div>
                                                    <ul>
                                                        <li title="商品标题">
                                                            <span className='hover defColor' onClick={() => { huoyuanLink(supplierProduct) }}>{supplierProduct.Subject}</span>
                                                            {/* <span className='paTag'>
                              {supplierProduct.SourcePlatform == 'TaoteZhuKe' ? '淘特' :
                                supplierProduct.IsJxhyOffer == true ? '1688精选' : '1688'}
                            </span> */}
                                                            {supplierProduct.PickupAssr ? <span className='productShow-content-sku-tag' style={{ alignItems: 'center' }}>{supplierProduct.PickupAssr}h晚揽必赔</span> : null}
                                                        </li>
                                                        <li className='supplierProduct-danger' style={{ display: 'flex' }}>
                                                            <span>供应商旺旺：{supplierProduct.SupplierLoginId}</span>
                                                            {
                                                                this.state.isShowDelSupplierProduct ?
                                                                    <div>
                                                                        <span className='hover iconfont icon-laji' onClick={() => { this.delSupplierProductDialog(supplierProduct, index) }}></span>
                                                                    </div> : null
                                                            }
                                                        </li>
                                                        <li>{
                                                            !supplierProduct.SupportEncryptOrder && this.state.platformType == "Taobao" ?
                                                                <span className='dangerColor'>货源不支持密文下单
                                                                    {
                                                                        this.state.isOrderListOpen ? <span style={{ marginLeft: '6px' }} className='hover defColor' onClick={() => { this.changeSupplierProduct(supplierProduct) }}>替换货源</span> : null
                                                                    }
                                                                </span>
                                                                : null
                                                        }</li>
                                                        <li>{
                                                            supplierProduct.SourcePlatform == 'TaoteZhuKe' ?
                                                                <span className='dangerColor'>! 已不支持淘特货源分销，请更换1688货源</span> : null
                                                        }</li>
                                                    </ul>
                                                </div>
                                            )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.tableRender()}
                    <div className="showModalWrap-box-commonfooter">
                        <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn " onClick={() => this.saveSure()}>确认匹配</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" style={{ marginLeft: "20px" }} onClick={() => { this.closeSkuMappingsModule() }}>取消</span>
                    </div>
                </div>
                <ShowModal
                    titleName={'确定是否更换'}
                    showLeftTopBtn={true}
                    width={500}
                    showModal={this.state.isOnlyOrderDialog}
                    skin={"changeProductsWrap"}
                    hideBtn={true}
                    className={'isOnlyOrderDialogWarp'}
                    cancelDailog={() => this.changeForm('isOnlyOrderDialog', false)} >
                    <div className='isOnlyOrderDialogRadio showModalWrap-box-commonContent'>
                        <div className='isOnlyOrderDialogRadioItem'>
                            <input type="radio" name='only_order' value='1' />
                            <span>仅针对这笔订单</span>
                            <div>
                                <span>不保存关联关系，下次下单还是使用原货源</span>
                            </div>
                        </div>
                        <div className='isOnlyOrderDialogRadioItem'>
                            <input type="radio" name='only_order' value='0' />
                            <span>此店铺商品产生的订单全部更换为新货源</span>
                            <div>
                                <span>保存关联关系，下次下单全部使用新货源</span>
                            </div>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span onClick={() => this.choiceRelevanceRequest()} style={{ display: 'flex' }}
                            className="showModalWrap-box-footer-btn">确定关联</span>
                        <span onClick={() => this.setState({ isOnlyOrderDialog: false })} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>
                <ShowModal showModal={this.state.delSupplierProductDialog} hideBtn={true} title={'删除货源'}>
                    <div className="showModalWrap-box-commonContent" style={{ padding: "20px", fontSize: "16px" }}>
                        <div className="showModalWrap-commonContent-item">
                            <i className="iconfont icon-wenhao icofontStatus"></i>
                            {
                                this.state.delSupplierProductHasMapping ?
                                    <span>检测到当前货源已在规格匹配中使用，店铺商品被下单，将无法采购该货源，已经存在的采购单不会受影响</span>
                                    : <span>删除后，店铺商品被下单，将无法采购该货源，已经存在的采购单不会受影响</span>
                            }
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span onClick={() => this.delSupplierProduct()} className="showModalWrap-box-footer-btn">确定</span>
                        <span onClick={() => this.changeForm('delSupplierProductDialog', false)} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>
                <MyLoading isLoading={this.state.isLoading} title={this.state.loadingTitle} isStopOperate={true} fullCenter={true} />
            </ShowModal>
        );
    }



};

export default withRouter(skuMappingsModule);



// WEBPACK FOOTER //
// ./src/components/skuMappingsModule/index.jsx